<template>
	<div
		class="mail"
		:class="{
			'mail--invalid': !isValid,
			'mail--focused': isFocused,
		}"
	>
		<span class="mail_text" :data-fake="mailInfo.mail">
			<input
				class="mail_input"
				ref="input"
				type="email"
				:value="mailInfo.mail"
				@keydown.delete="deleteMailTxt"
				@keypress.space="addNewEmail"
				@keypress.enter="addNewEmail"
				@input="updateEmail"
			/>
		</span>
		<md-button class="md-icon-button mail_close" @click="deleteEmail">
			<i class="icons icons-close" />
		</md-button>
	</div>
</template>

<script>
import {validateEmail} from '@/util/validateEmail.js';
export default {
	name: 'ShareModalEmailItem',
	props: {
		mailInfo: {
			type: Object,
		},
	},
	mounted() {
		this.$refs.input.addEventListener('focus', this.onFocus);
		this.$refs.input.addEventListener('blur', this.onBlur);
	},
	beforeDestroy() {
		this.$refs.input.removeEventListener('focus', this.onFocus);
		this.$refs.input.removeEventListener('blur', this.onBlur);
	},
	data() {
		return {
			isFocused: false,
		};
	},
	computed: {
		isValid() {
			return this.isFocused || validateEmail(this.mailInfo.mail);
		},
	},
	methods: {
		focus() {
			this.$refs.input.focus();
		},
		onFocus() {
			this.isFocused = true;
		},
		onBlur() {
			this.isFocused = false;
			if (!this.mailInfo.mail) this.deleteEmail();
		},
		parsedEmail(str) {
			let list = str.split(/,| /).filter((mail) => mail.length);
			return list.length > 1 ? list : str;
		},
		updateEmail(e) {
			const mail = this.parsedEmail(e.target.value.trim());
			const index = this.mailInfo.index;
			if (typeof mail === 'string') this.$emit('update-mail', {mail, index});
			else this.addEmailList(mail);
		},
		deleteMailTxt(e) {
			if (e.keyCode === 8 && !this.mailInfo.mail && this.mailInfo.index) {
				this.deleteEmail(this.mailInfo.index - 1);
			}
		},
		deleteEmail(index = this.mailInfo.index) {
			this.$emit('remove-mail', index);
		},
		addEmail(index, newList) {
			this.$emit('add-mail', {index, newList});
		},
		addNewEmail(event) {
			event?.preventDefault();
			this.addEmail(this.mailInfo.index, ['']);
		},
		addEmailList(list) {
			this.addEmail(this.mailInfo.index, list);
			this.$nextTick(() => this.deleteEmail());
		},
	},
};
</script>

<style lang="scss" scoped>
$input-side-p: 7px;
$input-padding: 2.5px $input-side-p;
.mail {
	display: flex;
	align-items: center;
	min-height: 2em;
	max-width: 100%;
	color: $color-blue;
	background: $color-super-light-blue;
	border: 1px solid;
	border-radius: 8px;
	font-weight: 400;
	padding-right: 1px;
	transition-duration: 0s;
}
.mail--invalid {
	color: $color-red;
	background: transparent;
}
.mail--focused {
	color: $color-text-grey;
	background: transparent;
	border-color: transparent;
}
.mail_text {
	position: relative;
	display: block;
	letter-spacing: 0.4px;
	padding: $input-padding;
	height: 100%;
	min-width: calc(#{$input-side-p} * 2 + 4px);
	&:before {
		content: attr(data-fake);
		opacity: 0;
	}
}
.mail_input {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	min-width: 0;
	padding: $input-padding;
	border: none;
	background-color: transparent;
	letter-spacing: inherit;
	outline: none;
	text-overflow: ellipsis;
}
.mail_close {
	width: 20px;
	min-width: 20px;
	height: 20px;
	margin: 0;
	transition-duration: 0s;
	&:before {
		transition-duration: 0s;
	}
	::v-deep {
		.md-ripple {
			padding: 0;
		}
	}
	.mail--focused & {
		visibility: hidden;
		opacity: 0;
	}
}
</style>
